import React, {ReactElement} from 'react';
import icon from '@assets/images/medops/home_icon.svg';
const HomeIcon = (props: any): ReactElement => {
  return <img src={icon} {...props} />;
};
export default HomeIcon;
